<template>
    <div>
        <el-row :gutter="20"
                style="margin-bottom: 20px">
            <el-col :span="8">
                <el-radio-group v-model="filter.type">
                    <el-radio-button :label="2">{{$t('accounting.toBePaid')}}</el-radio-button>
                    <el-radio-button :label="6">{{$t('accounting.paidAndPrinted')}}</el-radio-button>
                </el-radio-group>
            </el-col>
            <el-col :span="3">
                <el-date-picker v-model="filter.dateFrom"
                                type="date"
                                :placeholder="$t('common.dateFrom')"
                                style="width: 100%;"></el-date-picker>
            </el-col>
            <el-col :span="3">
                <el-date-picker v-model="filter.dateTo"
                                type="date"
                                :placeholder="$t('common.dateTo')"
                                style="width: 100%;"></el-date-picker>
            </el-col>
            <el-col :span="6">
                <el-input prefix-icon="el-icon-search"
                          v-model="filter.q"
                          :placeholder="$t('accounting.claimInvoiceCustomer')"></el-input>
            </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="3"
                    v-if="IsShownPayAndPrint">
                <el-button @click="payAndPrintConfirm"
                           :title="$t('accounting.payAndPrintSelectedClaims')">{{$t('accounting.payAndPrintSelectedClaims')}}</el-button>
            </el-col>
        </el-row>
        <el-table size="mini"
                  :data="claims"
                  v-loading="loading"
                  class="claims-table tablewithshading"
                  @selection-change="handleSelectionChange">
            <el-table-column type="selection"
                             width="55"
                             v-if="filter.type == 2"></el-table-column>
            <el-table-column prop="claimNumber"
                             :label="$t('common.claimNumber')"></el-table-column>
            <el-table-column prop="invoiceNumber"
                             :label="$t('common.invoiceNumber')"></el-table-column>
            <el-table-column :label="$t('common.total')">
                <template slot-scope="scope">
                    {{scope.row.total | money }}
                </template>
            </el-table-column>
            <el-table-column v-if="$i18n.locale == 'en'" prop="status"
                             :label="$t('common.status')"></el-table-column>
            <el-table-column v-else prop="statusFr"
                             :label="$t('common.status')"></el-table-column>
            <el-table-column prop="raisedBy"
                             :label="$t('common.raisedBy')"></el-table-column>
            <el-table-column :label="$t('serviceTickets.raisedOn')">
                <template slot-scope="scope">
                    {{scope.row.raisedOn | date }}
                </template>
            </el-table-column>
            <el-table-column :label="$t('common.operations')"
                             fixed="right"
                             width="220">
                <template slot-scope="scope">
                    <el-button size="mini"
                               @click="viewClaim(scope.row.id)">
                        <i class="el-icon-view"></i>
                    </el-button>
                    <el-button size="mini"
                               @click="payClaimConfirm(scope.row.id)"
                               :title="$t('accounting.payClaim')"
                               v-if="filter.type == 2">
                        {{$t('common.pay')}}
                    </el-button>
                    <el-button size="mini"
                               @click="printClaim(scope.row.id)"
                               :title="$t('accounting.printClaim')"
                               v-if="filter.type == 6">
                        <i class="el-icon-printer"></i>
                    </el-button>
                    <el-button size="mini"
                               type="danger"
                               @click="deleteClaim(scope.row.id)"
                               v-if="$isFullAdmin || ($isUser && scope.row.status == 'Partial')">
                        <i class="el-icon-delete"></i>
                    </el-button>
                    <!-- <el-button size="mini" @click="processClaimConfirm(scope.row.id)" title="Process claim" v-if="filter.type == 6">
              <i class="el-icon-check"></i>
            </el-button> -->
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="pager"
                       v-if="total !== 0"
                       @current-change="handleCurrentChange"
                       :current-page.sync="currentPage"
                       :page-size="15"
                       layout="total, prev, pager, next"
                       :total="total">
        </el-pagination>
        <preview-claim-dialog :claimId="claimToView"
                              :noDetails="true"
                              :visible="previewClaimVisible"
                              @dialogClosed="previewClaimFinished"></preview-claim-dialog>

        <el-dialog :title="$t('accounting.areYouSureThatYouWantoProcessClaim')"
                   :visible.sync="processClaimConfirmationVisible"
                   width="40%"
                   :close-on-click-modal="false">
            <span v-loading="loading">{{$t('accounting.thisActionWillChangeStatusOfThisClaim')}}</span>
            <span slot="footer"
                  class="dialog-footer">
                <el-button @click="processClaimConfirmationVisible = false">{{$t('common.no')}}</el-button>
                <el-button type="primary"
                           @click="processClaim(claimId)">{{$t('common.yes')}}</el-button>
            </span>
        </el-dialog>

        <el-dialog :title="$t('accounting.areYouSureThatYouWantToPayClaim')"
                   :visible.sync="payClaimConfirmationVisible"
                   width="40%"
                   :close-on-click-modal="false">
            <span v-loading="loading">{{$t('accounting.thisActionWillChangeStatusOfThisClaim')}}</span>
            <span slot="footer"
                  class="dialog-footer">
                <el-button @click="payClaimConfirmationVisible = false">{{$t('common.no')}}</el-button>
                <el-button type="primary"
                           @click="payClaim(claimId)">{{$t('common.yes')}}</el-button>
            </span>
        </el-dialog>
        <el-dialog :title="$t('accounting.areYouSureThatYouWantToPayAndPrintAllSelectedClaims')"
                   :visible.sync="payAndPrintConfirmationVisible"
                   width="50%"
                   :close-on-click-modal="false">
            <span v-loading="loading">{{$t('accounting.thisActionWillChangeStatusOfThisClaim')}}</span>
            <span slot="footer"
                  class="dialog-footer">
                <el-button @click="payAndPrintConfirmationVisible = false">{{$t('common.no')}}</el-button>
                <el-button type="primary"
                           @click="payAndPrint(claimId)">{{$t('common.yes')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import api from "../api";
    import { PreviewClaimDialog } from "../../claims/components";

    export default {
        name: "claims-list",
        components: {
            PreviewClaimDialog
        },
        data() {
            return {
                loading: false,
                claims: [],
                filter: {
                    type: 2,
                    q: "",
                    dateFrom: null,
                    dateTo: null
                },
                currentPage: 1,
                total: 0,
                claimToView: undefined,
                claimToEdit: undefined,
                previewClaimVisible: false,

                claimId: undefined,
                processClaimConfirmationVisible: false,
                payClaimConfirmationVisible: false,

                selectedClaims: [],
                payAndPrintConfirmationVisible: false
            };
        },
        watch: {
            filter: {
                deep: true,
                handler: function () {
                    this.loadClaims();
                }
            }
        },
        created() {
            this.loadClaims();
        },
        computed: {
            IsShownPayAndPrint() {
                return this.selectedClaims.length > 0;
            }
        },
        methods: {
            payClaim(id) {
                this.loading = true;
                api.payClaim(id).then(() => {
                    this.loading = false;
                    this.loadClaims();
                    this.payClaimConfirmationVisible = false;
                    this.claimToView = id;
                    this.previewClaimVisible = true;
                });
            },
            payClaimConfirm(id) {
                this.claimId = id;
                this.payClaimConfirmationVisible = true;
            },
            printClaim(id) {
                api.printClaim(id).then(response => {
                    var oHiddFrame = document.createElement("iframe");
                    oHiddFrame.style.visibility = "hidden";
                    oHiddFrame.style.position = "fixed";
                    oHiddFrame.style.right = "0";
                    oHiddFrame.style.bottom = "0";
                    oHiddFrame.src = "javascript:void(0)";
                    document.body.appendChild(oHiddFrame);
                    var dstDoc =
                        oHiddFrame.contentDocument || oHiddFrame.contentWindow.document;
                    dstDoc.write(response.data);

                    dstDoc.close();
                    var isFirefox = typeof InstallTrigger !== "undefined";
                    if (isFirefox) {
                        oHiddFrame.contentWindow.print();
                        document.body.removeChild(oHiddFrame);
                    } else {
                        setTimeout(function () {
                            oHiddFrame.contentWindow.print();
                            document.body.removeChild(oHiddFrame);
                        }, 500);
                    }
                });
            },
            processClaim(id) {
                api.processClaim(id).then(() => {
                    this.loadClaims();
                    this.processClaimConfirmationVisible = false;
                });
            },
            processClaimConfirm(id) {
                this.claimId = id;
                this.processClaimConfirmationVisible = true;
            },
            loadClaims() {
                this.loading = true;
                api.getClaims(this.currentPage, this.filter).then(response => {
                    this.loading = false;
                    this.claims = response.data.items;
                    this.total = response.data.total;
                });
            },
            deleteClaim(id) {
                this.$confirm(this.$t('common.thisWillDeleteClaimContinue'), "Warning", {
                    confirmButtonText: this.$t('common.OK'),
                    cancelButtonText: this.$t('common.cancel'),
                    type: "warning"
                })
                    .then((res) => {
                        api.deleteClaim(id).then(() => {
                            this.loadClaims();
                            this.$message({
                                type: "success",
                                message: this.$t('common.deleteCompleted')
                            });
                        });
                    })
                    .catch(_ => {
                        console.warn(_)
                    });
            },
            handleCurrentChange(page) {
                this.currentPage = page;
                this.loadClaims();
            },
            viewClaim(id) {
                this.claimToView = id;
                this.previewClaimVisible = true;
            },
            showClaimPreview(id) {
                this.claimToView = id;
                this.previewClaimVisible = true;
            },
            previewClaimFinished() {
                this.claimToView = undefined;
                this.previewClaimVisible = false;
            },
            claimPublished() {
                this.$notify({
                    title: this.$t('common.success'),
                    message: this.$t('common.claimSuccesfullySubmitted'),
                    type: "success"
                });
                this.loadClaims();
            },
            payAndPrintConfirm() {
                this.payAndPrintConfirmationVisible = true;
            },
            payAndPrint() {
                this.loading = true;
                api.payAndPrint(this.selectedClaims).then(response => {

                    this.payClaimConfirmationVisible = false;
                    this.claimToView = this.selectedClaims[0];
                    this.previewClaimVisible = true;
                    this.loading = false;

                    var oHiddFrame = document.createElement("iframe");
                    oHiddFrame.style.visibility = "hidden";
                    oHiddFrame.style.position = "fixed";
                    oHiddFrame.style.right = "0";
                    oHiddFrame.style.bottom = "0";
                    oHiddFrame.src = "javascript:void(0)";
                    document.body.appendChild(oHiddFrame);
                    var dstDoc =
                        oHiddFrame.contentDocument || oHiddFrame.contentWindow.document;
                    dstDoc.write(response.data);

                    dstDoc.close();
                    var isFirefox = typeof InstallTrigger !== "undefined";
                    if (isFirefox) {
                        oHiddFrame.contentWindow.print();
                        document.body.removeChild(oHiddFrame);
                    } else {
                        setTimeout(function () {
                            oHiddFrame.contentWindow.print();
                            setTimeout(function () {

                            }, 300);
                            document.body.removeChild(oHiddFrame);
                        }, 3000);
                    }

                    this.payAndPrintConfirmationVisible = false;
                    this.loadClaims();
                });
            },
            handleSelectionChange(val) {
                this.selectedClaims = val.map(item => {
                    return item.id;
                });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// ClientApp/app/accounting/components/ClaimsList.vue